export default __webpack_public_path__ + "static/media_hero-1e4695f4744c49dda28d511daafe240c.jpg";